<script setup>
import CurrentYearTable from './CurrentYearTable.vue';
import LegacyCategoryLegend from './LegacyCategoryLegend.vue';
import LegacyYearTable from './LegacyYearTable.vue';

const props = defineProps({
  yearData: {
    type: Object,
    required: true,
  },
});

const formatNumber = value => value?.toLocaleString() ?? '—';
</script>

<template>
  <section
    :id="`year-${props.yearData.year}`"
    class="mb-5"
  >
    <h2>{{ props.yearData.year }} top contributors</h2>
    <p class="text-muted">
      Wider community contributors: {{ formatNumber(props.yearData.totalContributors) }} ·
      Merged MRs: {{ formatNumber(props.yearData.totalMergedMRs) }}
    </p>

    <CurrentYearTable
      v-if="props.yearData.type === 'current'"
      :contributors="props.yearData.contributors"
      :from-date="props.yearData.fromDate"
      :to-date="props.yearData.toDate"
    />
    <template v-else>
      <LegacyYearTable :contributors="props.yearData.contributors" />
      <LegacyCategoryLegend />
    </template>
  </section>
</template>
